import { render, staticRenderFns } from "./onlyCategory.vue?vue&type=template&id=1c4f2862&scoped=true&"
import script from "./onlyCategory.vue?vue&type=script&lang=js&"
export * from "./onlyCategory.vue?vue&type=script&lang=js&"
import style0 from "./onlyCategory.vue?vue&type=style&index=0&id=1c4f2862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f2862",
  null
  
)

export default component.exports